module.exports=function(scope){ return `<!-- enrollmentIdentifier found in database -->
{
    "data": {
        "auditTrailImage": "...";
        "faceMap": "...",
    },
    "meta": {
        "code": 200,
        "ok": true,
        "message": "A FaceMap was found for that enrollmentIdentifier."
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/response/success/enrollment-get-facemap.json.tpl